<script lang="ts">
    import { onMount } from 'svelte';
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import { hexToRgb, isHexString, isRgbaString, rgbaToRgb } from '../helper';

    let mounted = false;

    onMount(() => {
        mounted = true;
    });

    export let color = '#0076FF';
    export let pageId = '';
    export let sortedPages: string[] = [];
    export let hasResultPages = false;

    // Set color
    let rgb: { r: number; g: number; b: number } = {
        r: 0,
        g: 0,
        b: 0,
    };

    if (isRgbaString(color)) {
        rgb = rgbaToRgb(color);
    } else if (isHexString(color)) {
        rgb = hexToRgb(color);
    }

    const bgColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, .2)`;

    const animationOptions = {
        duration: 1600,
        easing: cubicOut,
    };

    // Calculate Progress
    let progress;

    $: total = hasResultPages ? sortedPages.length + 1 : sortedPages.length;
    $: index = sortedPages.indexOf(pageId);

    // Wait with reactivity until DOM is ready
    // https://stackoverflow.com/questions/64639780/how-do-you-write-a-reactive-statement-in-svelte-sapper-when-it-needs-to-access-a
    $: if (mounted) {
        if (index === -1) {
            progress = tweened(((total - 1) / total) * 100, animationOptions);
            progress.set(100);
        } else {
            progress = tweened((index / total) * 100, animationOptions);
            progress.set(((index + 1) / total) * 100);
        }
    }
</script>

<div class="fixed bottom-0 z-10 h-1 w-full" style="background-color: {bgColor}">
    progress
    <div
        class="absolute top-0 left-0 h-full"
        style="background-color: {color}; width: {$progress}%"
    />
</div>
